import React from 'react';

import Paper from 'material-ui/Paper';

import CourseAssignmentList from './CourseAssignmentList';
import CourseInstructorList from './CourseInstructorList';

function CourseRelationController(props) {
  const paperStyles = {
    flexGrow: 1, 
    margin: '5px 10px 10px 10px', 
    height: '100%',
  };

  return (
      <div className='course-relation-container'>
        <Paper 
          className='course-detail-relations-box' 
          style={paperStyles}
          zDepth={1}>
          <CourseInstructorList course={props.course} />
        </Paper>
      
        <Paper 
          className='course-detail-relations-box' 
          style={paperStyles} 
          zDepth={1}>
          <CourseAssignmentList course={props.course} />
        </Paper>
      </div>
  );
}

export default CourseRelationController;


// WEBPACK FOOTER //
// ./src/scenes/Organizer/components/CourseRelationController.js